export default "__VITE_ASSET__d15f1627__"